import { EditIcon, SettingsIcon, WalletIcon } from 'lucide-react-native';
import { useState } from 'react';
import { YStack } from 'tamagui';

import { CheckboxRow } from '../../components/rows/CheckboxRow';
import { RowList } from '../../components/rows/RowList';
import { TextRow } from '../../components/rows/TextRow';
import { H6Regular } from '../../components/text/Typography';

export const RowHeaders = () => {
    const [checkbox1, setCheckbox1] = useState(false);

    return (
        <YStack gap={32}>
            {/* Single TextRow with Header */}
            <YStack gap={12}>
                <H6Regular>Single TextRow with Header</H6Regular>
                <YStack gap={8}>
                    <RowList
                        rowHeaderProps={{
                            title: 'Account Information',
                        }}
                    >
                        <TextRow
                            title="Account number"
                            secondaryText="****6789"
                        />
                    </RowList>
                </YStack>
            </YStack>

            {/* Single CheckboxRow with Header */}
            <YStack gap={12}>
                <H6Regular>Single CheckboxRow with Header</H6Regular>
                <YStack gap={8}>
                    <RowList
                        rowHeaderProps={{
                            title: 'Settings',
                        }}
                    >
                        <CheckboxRow
                            title="Enable Notifications"
                            onPress={() => {
                                setCheckbox1(!checkbox1);
                            }}
                            checkboxProps={{
                                checked: checkbox1,
                                onPress: () => {
                                    setCheckbox1(!checkbox1);
                                },
                            }}
                        />
                    </RowList>
                </YStack>
            </YStack>

            {/* Header with Title Only */}
            <YStack gap={12}>
                <H6Regular>Header with Title Only</H6Regular>
                <YStack gap={8}>
                    <RowList
                        rowHeaderProps={{
                            title: 'Account Information',
                        }}
                    >
                        <TextRow
                            title="Email"
                            secondaryText="user@example.com"
                        />
                        <TextRow title="Phone" secondaryText="(555) 123-4567" />
                    </RowList>
                </YStack>
            </YStack>

            {/* Header with Title and Subtitle */}
            <YStack gap={12}>
                <H6Regular>Header with Title and Subtitle</H6Regular>
                <YStack gap={8}>
                    <RowList
                        rowHeaderProps={{
                            title: 'Free to spend',
                            subtitle: 'Cash account',
                        }}
                    >
                        <TextRow
                            title="Available balance"
                            secondaryText="$5,234.56"
                        />
                        <TextRow
                            title="Pending transfers"
                            secondaryText="$0.00"
                        />
                    </RowList>
                </YStack>
            </YStack>

            {/* Header with Title and Label */}
            <YStack gap={12}>
                <H6Regular>Header with Title and Label</H6Regular>
                <YStack gap={8}>
                    <RowList
                        rowHeaderProps={{
                            title: 'Your bills',
                            label: '20 bills',
                        }}
                    >
                        <TextRow
                            title="Electric Bill"
                            secondaryText="$150.00"
                        />
                        <TextRow title="Water Bill" secondaryText="$75.00" />
                    </RowList>
                </YStack>
            </YStack>

            {/* Header with Left Icon */}
            <YStack gap={12}>
                <H6Regular>Header with Left Icon</H6Regular>
                <YStack gap={8}>
                    <RowList
                        rowHeaderProps={{
                            title: 'Free to spend',
                            subtitle: 'Cash account',
                            leftIcon: WalletIcon,
                        }}
                    >
                        <TextRow
                            title="Available balance"
                            secondaryText="$5,234.56"
                        />
                        <TextRow
                            title="Pending transfers"
                            secondaryText="$0.00"
                        />
                    </RowList>
                </YStack>
            </YStack>

            {/* Header with Primary Button */}
            <YStack gap={12}>
                <H6Regular>Header with Primary Button</H6Regular>
                <YStack gap={8}>
                    <RowList
                        rowHeaderProps={{
                            title: 'Settings',
                            primaryButton: {
                                icon: EditIcon,
                                onPress: () => {},
                                variant: 'tertiary',
                            },
                        }}
                    >
                        <TextRow
                            title="Email"
                            secondaryText="user@example.com"
                        />
                        <TextRow title="Phone" secondaryText="(555) 123-4567" />
                    </RowList>
                </YStack>
            </YStack>

            {/* Header with Both Buttons */}
            <YStack gap={12}>
                <H6Regular>Header with Both Buttons</H6Regular>
                <YStack gap={8}>
                    <RowList
                        rowHeaderProps={{
                            title: 'Profile Settings',
                            subtitle: 'Manage your profile',
                            primaryButton: {
                                icon: EditIcon,
                                onPress: () => {},
                                variant: 'tertiary',
                            },
                            secondaryButton: {
                                icon: SettingsIcon,
                                onPress: () => {},
                                variant: 'tertiary',
                            },
                        }}
                    >
                        <TextRow
                            title="Email"
                            secondaryText="user@example.com"
                        />
                        <TextRow title="Phone" secondaryText="(555) 123-4567" />
                    </RowList>
                </YStack>
            </YStack>

            {/* Header with All Options */}
            <YStack gap={12}>
                <H6Regular>Header with All Options</H6Regular>
                <YStack gap={8}>
                    <RowList
                        rowHeaderProps={{
                            title: 'Account Information',
                            subtitle: 'Cash account details',
                            label: '3 accounts',
                            leftIcon: WalletIcon,
                            primaryButton: {
                                icon: EditIcon,
                                onPress: () => {},
                                variant: 'tertiary',
                            },
                            secondaryButton: {
                                icon: SettingsIcon,
                                onPress: () => {},
                                variant: 'tertiary',
                            },
                        }}
                    >
                        <TextRow
                            title="Account number"
                            secondaryText="****6789"
                        />
                        <TextRow
                            title="Routing number"
                            secondaryText="****4321"
                        />
                    </RowList>
                </YStack>
            </YStack>
        </YStack>
    );
};
